
const digest = '4d6c89336f11cf0ddedda1ef636089d92482c85b0086f9178515dcf5739c24be';
const classes = {"wrapper":"_wrapper_15ic8_1","alert":"_alert_15ic8_9","text":"_text_15ic8_19","controls":"_controls_15ic8_23"};
const css = `._wrapper_15ic8_1 {
  background: rgb(255, 241, 241);
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  gap: 12px;
  margin: 20px -20px;
}
._wrapper_15ic8_1 ._alert_15ic8_9 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._wrapper_15ic8_1 ._alert_15ic8_9 img {
  height: 50px;
  width: 50px;
}
._wrapper_15ic8_1 ._alert_15ic8_9 ._text_15ic8_19 {
  font-weight: 600;
  color: rgb(179, 35, 35);
}
._wrapper_15ic8_1 ._controls_15ic8_23 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  